/* eslint-disable no-nested-ternary */
import React, { useMemo, useState } from "react";
import { Panel, Dropdown, Loader } from "@culturehq/components";
import * as CHQ from "chq";

import { useFieldsLabels, useGet } from "app/hooks";
import { Trans, formatThousand } from "app/utils";

import ProgressLine from "./ProgressLine";
import getColorList from "./getColorList";

type SegmentChartProps = {
  segments: CHQ.RsvpSegment[];
};

const SegmentChart: React.FC<SegmentChartProps> = ({ segments }) => {
  const maxValue = Math.max(...segments.map(({ total }) => total));
  const colors = useMemo(() => getColorList(segments.length), [segments.length]);

  return (
    <>
      {segments.map((segment, index) => (
        <div key={segment.name} className="row_bar">
          <div className="info_label">{segment.name}</div>
          <ProgressLine
            color={colors[index]}
            valueNow={segment.total}
            valueMax={maxValue}
          />
          <div className="info_txt">{formatThousand(segment.total)}</div>
        </div>
      ))}
    </>
  );
};

type EventSegmentContentProps = {
  filter: string;
};

export type ListRsvpSegments = {
  segments: CHQ.RsvpSegment[];
};

const EventSegmentContent: React.FC<EventSegmentContentProps> = ({ filter }) => {
  const get = useGet<ListRsvpSegments>(`/analytics/rsvps/segments/${filter}`);

  if (get.getting) {
    return <Loader loading />;
  }

  if (get.error) {
    throw get.error;
  }

  return (
    <div className="card_info">
      {
        get.got.segments.length > 0
          ? <SegmentChart segments={get.got.segments} />
          : <Trans>No data</Trans>
      }
    </div>
  );
};

const EventSegment: React.FC = () => {
  const labels = useFieldsLabels();
  const [filter, setFilter] = useState("departments");

  return (
    <Panel>
      <Panel.Body className="card_holder">
        <div className="card_title">
          <h3>
            <Trans>Most Engaged Segments</Trans>
          </h3>
          <Dropdown selected={filter} onChange={setFilter}>
            <Dropdown.Button>
              <Trans>Segment By</Trans>
            </Dropdown.Button>
            <Dropdown.ListBox className="custom_option">
              <Dropdown.Option value="departments">
                <Trans>{labels.departments.plural}</Trans>
              </Dropdown.Option>
              <Dropdown.Option value="locations">
                <Trans>Locations</Trans>
              </Dropdown.Option>
              <Dropdown.Option value="interests">
                <Trans>Interests</Trans>
              </Dropdown.Option>
              <Dropdown.Option value="skills">
                <Trans>Skills</Trans>
              </Dropdown.Option>
            </Dropdown.ListBox>
          </Dropdown>
        </div>
        <EventSegmentContent filter={filter} />
      </Panel.Body>
    </Panel>
  );
};

export default EventSegment;
